import { Box, Typography } from '@material-ui/core'
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'

import CustomTooltip from '../common/customTooltip';
// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const grid = 8

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // padding: grid * 2,
  padding: 5,
  position: 'relative',
  paddingBottom: 0,
  // margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : 'grey',

  // styles we need to apply on draggables
  ...draggableStyle,
})

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'lightblue' : 'lightgrey',
  padding: grid,
  width: 450,
})

const DraggableList = ({ data, title, onDataOrderChange }) => {
  const [items, setItems] = useState([])

  useEffect(() => {
    setItems(data)
  }, [data])

  const onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const orderedItems = reorder(
      items,
      result.source.index,
      result.destination.index
    )

    setItems(orderedItems)

    if (onDataOrderChange) {
      onDataOrderChange(orderedItems)
    }
  }

  const onRemoveItems = selectedItem => {
    if (selectedItem && selectedItem._id) {
      const index = data.findIndex(itx => itx._id === selectedItem._id)
      if (index !== -1) {
        data.splice(index, 1)
        const orderedItems = reorder(data, index, data.length)
        setItems(orderedItems)
        onDataOrderChange(orderedItems)
      }
    }
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {title && (
        <Box
          sx={{
            backgroundColor: "primary.main",
            color: "#fff",
            p: 2,
            borderRadius: 2,
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {/* Title */}
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "#fff",
            }}
          >
            {title}
          </Typography>

          {/* Instruction */}
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.9)",
              fontStyle: "italic",
            }}
          >
            💡 You can drag and drop the questions to change their order.
          </Typography>
        </Box>

      )}
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
          // style={getListStyle(snapshot.isDraggingOver)}
          >
            {items?.map((item, index) => {
              return (
                item && (
                  <Box key={item?._id} mt={"4px"}>
                    <Draggable
                      key={item?._id}
                      draggableId={item?._id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            {item.name}
                            <br />
                            Question:{' '}
                            <span id={`${item?._id}question`}>
                              {item?.question}
                            </span>
                            <br />
                            Question Type: {item?.questionType}
                            <p>Status: {item?.isActive?.toString()}</p>
                            <Box
                              display="flex"
                              justifyContent="end"
                              alignItems="center"
                              gap={0}
                              position="absolute"
                              right={2}
                              bottom={2}
                            >
                              <CustomTooltip title="Copy Question">
                                <IconButton
                                  sx={{ padding: 0 }}
                                  onClick={() =>
                                    navigator.clipboard.writeText(
                                      document.getElementById(`${item?._id}question`)
                                        .innerText
                                    )
                                  }
                                >
                                  <ContentCopyIcon sx={{ color: "white", cursor: "pointer", fontSize: "16px" }} />
                                </IconButton>
                              </CustomTooltip>

                              <CustomTooltip title="Remove Question">
                                <IconButton
                                  sx={{ padding: 0 }}
                                  onClick={() => {
                                    onRemoveItems(item)
                                  }}
                                >
                                  <DeleteIcon
                                    sx={{ color: "error.main", cursor: "pointer", fontSize: "20px" }}
                                  />
                                </IconButton>
                              </CustomTooltip>


                            </Box>
                          </div>
                        </>
                      )}
                    </Draggable>
                  </Box>
                )
              )
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext >
  )
}

DraggableList.propTypes = {
  data: PropTypes.array,
}

export default DraggableList
